/** Shared logo swap motion + rotation timing for customer grid blocks. */

export const LOGO_ROTATION_INTERVAL_MS = { min: 2000, max: 3000 } as const;

export const LOGO_PAUSE_AFTER_EXIT_S = 0.1;

const LOGO_EASE_IN = [0.4, 0, 0.6, 1] as const;
const LOGO_EASE_OUT = [0.22, 1, 0.36, 1] as const;

export const LOGO_SLIDE_OFFSET = {
  desktop: 10,
  compact: 6,
} as const;

export type CustomersGridMotionVariant = "compact" | "desktop";

export function getLogoMotionVariants(slideOffset: number) {
  return {
    initial: { opacity: 0, y: slideOffset },
    animate: {
      opacity: 1,
      y: 0,
      transition: {
        opacity: {
          duration: 0.36,
          ease: LOGO_EASE_OUT,
          delay: LOGO_PAUSE_AFTER_EXIT_S,
        },
        y: {
          duration: 0.4,
          ease: LOGO_EASE_OUT,
          delay: LOGO_PAUSE_AFTER_EXIT_S,
        },
      },
    },
    exit: {
      opacity: 0,
      y: 0,
      transition: {
        opacity: { duration: 0.32, ease: LOGO_EASE_IN },
        y: { duration: 0 },
      },
    },
  } as const;
}

export function getLogoSlideOffset(variant: CustomersGridMotionVariant) {
  return LOGO_SLIDE_OFFSET[variant];
}

export function getLogoRotationDelayMs() {
  const { min, max } = LOGO_ROTATION_INTERVAL_MS;
  return min + Math.random() * (max - min);
}

/** Fisher–Yates shuffle of slot indices `[0, length)`. */
export function createShuffledRotationOrder(
  length: number,
  random = Math.random
): number[] {
  const order = Array.from({ length }, (_, index) => index);
  for (let i = order.length - 1; i > 0; i--) {
    const j = Math.floor(random() * (i + 1));
    [order[i], order[j]] = [order[j]!, order[i]!];
  }
  return order;
}
